import { createSelector } from 'reselect';

import getSelectors from '../../shared/store/selectorsFactory';
import { adminPageNames } from '../../shared/adminPageNames';

export const sharedSelectors = getSelectors(adminPageNames.GL_ACCOUNT_LIST);

export const accountOptionsSelector = ({ administration }) =>
  administration[adminPageNames.GL_ACCOUNT_LIST].accounts;

export const listNameOptionsSelector = createSelector(
  ({ administration }) => administration[adminPageNames.GL_ACCOUNT_LIST].entities,
  glAccountList => glAccountList
    .map(({ listName }) => listName)
    .filter((value, idx, values) => values.indexOf(value) === idx)
    .map(value => ({ value, label: value }))
);

export const isFetchingInitialDataForAddAndEditModalSelector = ({ administration }) =>
  administration[adminPageNames.GL_ACCOUNT_LIST].isFetchingInitialDataForAddAndEditModal;
